module.exports = __webpack_public_path__ + "static/media/Home_icon7.69f92f50.png";